import { computed, Ref } from 'vue'

type OffsetInfo = {
  offset: Ref<number>
  limit: Ref<number> | number
}

export type SearchClientsQuery = OffsetInfo & {
  query: Ref<string>
}

export function useBuildSearchClientsQuery(
  currentPage: Ref<number>,
  itemsPerPage = 20,
  query: Ref<string>,
): SearchClientsQuery {
  const offset = computed(() => (currentPage.value - 1) * itemsPerPage)

  return {
    offset,
    limit: itemsPerPage,
    query,
  }
}
